module.exports = __webpack_public_path__ + "img/laptop-error.bed1f58b.png";